// Usage example
document.addEventListener('DOMContentLoaded', function () {
    const queryParams = getMembershipQueryParams();
    const { role, pricingMethod, interval } = queryParams;

    // Check if elements exist on the page
    if (document.querySelector(".mj-form__premium-info") && document.getElementById("user_type")) {
        // Your further logic here...
        if (pricingMethod == "premium" || pricingMethod == "premium-plus") {
            document.querySelector(".mj-form__premium-info").style.display = "flex";
            document.getElementById("user_type").setAttribute("value", pricingMethod);

            document.querySelector(".mj-form__progress").classList.add("--premium");
        } else {
            document.querySelector(".mj-form__premium-info").style.display = "none";
            document.getElementById("user_type").setAttribute("value", "free");
        }
    }

    // Check if elements exist on the page
    if (document.getElementById("user_role")) {
        // Your further logic here...
        if (role == "venue") {
            document.getElementById("user_role").setAttribute("value", "venue_partner");
        } else if (role == "supplier") {
            document.getElementById("user_role").setAttribute("value", "supplier_partner");
        } else if (role == "client") {
            document.getElementById("user_role").setAttribute("value", "client");
            document.querySelector(".mj-form__premium-info").classList.add("--membership");
        }
    }

    handleStepNavigation(1);
});

jQuery(document).on('click', '.mj-form__submission-btn-next', function (e) {

    e.preventDefault();

    const currentStepElement = document.querySelector('.mj-form-submission__step.show');
    const currentStepNumber = parseInt(currentStepElement.getAttribute('data-step'));

    if (validateStep(currentStepNumber)) {
        const nextStepNumber = currentStepNumber + 1;
        handleStepNavigation(nextStepNumber);
    }

});

jQuery(document).on('click', '.mj-form__submission-btn-prev', function (e) {

    e.preventDefault();

    const currentStepElement = document.querySelector('.mj-form-submission__step.show');
    const currentStepNumber = parseInt(currentStepElement.getAttribute('data-step'));
    const prevStepNumber = currentStepNumber - 1;

    handleStepNavigation(prevStepNumber);

});

document.addEventListener("DOMContentLoaded", function () {
    // Listen for change event on all radio buttons with class 'active-step input[type="radio"]'
    var radioButtons = document.querySelectorAll('.active-step input[type="radio"]');
    radioButtons.forEach(function (radioButton) {

        radioButton.addEventListener('click', function () {

            // Remove the 'active' class from all elements with class '.mj-form__image-btn'
            var imageBtns = document.querySelectorAll('.mj-form__image-btn');
            imageBtns.forEach(function (btn) {
                btn.classList.remove('active');
            });

            var closestImageBtn = this.closest('.mj-form__image-btn');
            closestImageBtn.classList.add('active');

            var closestStepId = this.closest('.mj-form__step').getAttribute('data-step');
            var currentStepNumber = parseInt(closestStepId, 10);
            var nextStepNumber = parseInt(closestStepId, 10) + 1;

            // Update hidden input value with the clicked radio button value
            var partnerTypeInput = document.getElementById('user_role');
            var memberTypeInput = document.getElementById('user_type');
            var memberInterval = document.getElementById('user_interval');
            var membershipLocation = document.getElementById('user_location');

            if (partnerTypeInput) {
                partnerTypeInput.value = this.value + "_partner";
            }

            handleStepNavigation(nextStepNumber);

            // Check if .mj-form__premium-price element exists
            const premiumPriceElement = document.querySelector('.mj-form__premium-price-value');

            if (premiumPriceElement) {
                // Assuming this.value refers to some variable or element value
                const value = this.value;

                // Check if value is 'venue' or 'supplier' and set the premium price accordingly
                if (membershipLocation.value == 'ireland') {
                    if (value === 'venue') {
                        premiumPriceElement.textContent = '€1,999';
                    } else if (value === 'supplier') {
                        premiumPriceElement.textContent = '€1,499';
                    } else if (value === 'client') {
                        if (memberTypeInput == 'premium') {
                            premiumPriceElement.textContent = '0';
                        } else if (memberTypeInput == 'premium-plus') {
                            if (memberInterval == 'yearly') {
                                premiumPriceElement.textContent = '€249';
                            } else if (memberInterval == 'monthly') {
                                premiumPriceElement.textContent = '€24.9';
                            }
                        }
                    }
                } else {
                    if (value === 'venue') {
                        premiumPriceElement.textContent = '£1,000';
                    } else if (value === 'supplier') {
                        premiumPriceElement.textContent = '£800';
                    } else if (value === 'client') {
                        if (memberInterval == 'yearly') {
                            premiumPriceElement.textContent = '£120';
                        } else if (memberInterval == 'monthly') {
                            premiumPriceElement.textContent = '£15.99';
                        }
                    }
                }

            }

            var partnerPriceTitle = document.querySelector(".mj-form__premium-title-type");
            if (partnerPriceTitle) {
                partnerPriceTitle.textContent = this.value;
            }
        });
    });
});


jQuery(document).ready(function () {

    if ($('.mj-form-submission__step').length > 0) {

        const queryParams = getMembershipQueryParams();
        const { role, pricingMethod, interval } = queryParams;

        // handleStepNavigation(nextStepNumber);

        // Check if .mj-form__premium-price element exists
        const premiumPriceElement = document.querySelector('.mj-form__premium-price-value');
        const premiumPriceElementSuffix = document.querySelector('.mj-form__premium-price-vat');
        const premiumInterval = document.querySelector('.mj-form__premium-price-interval');
        var memberTypeInput = document.getElementById('user_type');
        var membershipLocation = document.getElementById('user_location');

        if (premiumPriceElement) {
            // Assuming this.value refers to some variable or element value
            // const value = this.value.value;
            // Check if value is 'venue' or 'supplier' and set the premium price accordingly
            if (membershipLocation.value == 'ireland') {
                if (memberTypeInput.value == 'premium') {
                    if (role === 'venue') {
                        premiumPriceElement.textContent = '€1,999';
                    } else if (role === 'supplier') {
                        premiumPriceElement.textContent = '€1,499';
                    } else if (role === 'client') {
                        premiumPriceElement.textContent = '0';
                        premiumPriceElementSuffix.textContent = ' /';
                    }
                } else if (memberTypeInput.value == 'premium-plus') {
                    if (role === 'venue') {
                        premiumPriceElement.textContent = '€1,999';
                    } else if (role === 'supplier') {
                        premiumPriceElement.textContent = '€1,499';
                    } else if (role === 'client') {
                        if (interval == 'yearly') {
                            premiumPriceElement.textContent = '€249';
                        } else if (interval == 'monthly') {
                            premiumPriceElement.textContent = '€24.99';
                        }
                    }
                }

            } else {
                if (role === 'venue') {
                    premiumPriceElement.textContent = '£1,000';
                } else if (role === 'supplier') {
                    premiumPriceElement.textContent = '£800';
                } else if (role === 'client') {
                    if (interval == 'yearly') {
                        premiumPriceElement.textContent = '£120';
                    } else if (interval == 'monthly') {
                        premiumPriceElement.textContent = '£15.99';
                    }
                }
            }

        }

        if (premiumInterval) {

            const value = this.value;
            if (interval === 'monthly') {
                premiumInterval.textContent = 'monthly';
            } else if (interval === "yearly") {
                premiumInterval.textContent = 'yearly';
            }
        }

        var partnerPriceTitle = document.querySelector(".mj-form__premium-title-type");
        if (partnerPriceTitle) {
            partnerPriceTitle.textContent = role;
        }
    }

    // Handler function to handle form submission
    function handleFormSubmission(event) {
        event.preventDefault(); // Prevents the form from submitting normally

        // Get the current step element
        const currentStepElement = document.querySelector('.mj-form-submission__step.show');
        const currentStepNumber = parseInt(currentStepElement.getAttribute('data-step'));
        const nextStepNumber = currentStepNumber + 1;

        // Get form action
        const formAction = $(this).attr('action');

        // Gather form data
        // var formData = $(this).serializeArray();

        var formData = $(this).serialize();
        var formType = $(this).find('input[name="user_role"]').val();
        formType = formType.replace('_partner', ''); // Remove "_partner" at the end of the formType variable

        formData += '&action=' + formAction;

        // Send form data via AJAX
        $.ajax({
            type: 'POST',
            url: missjones_data.ajax_url,
            data: formData,
            dataType: 'json',
            beforeSend: function () {
                // Show loading spinner before the AJAX request
            },
            success: function (response) {
                if (response.status === 'success') {
                    //alert(response.message);
                    showNotification(response.message, 'info');
                    // If the submission is successful, move to step 3
                    var newUrl = `${site_url_wpml()}list-with-us?type=${formType}`; // Append the query parameter to the base URL
                    window.location.href = newUrl;
                    //handleStepNavigation(nextStepNumber);

                } else {
                    //alert(response.message);
                    showNotification(response.message, 'error');
                    // Handle the case where submission fails, maybe show an error message
                    // You might want to add an error message display logic here
                }
            },
            error: function (error) {
                console.error('AJAX Error:', error);
            }
        });
    }

    // Handler function to handle form submission
    function handleMemberSubmission(event) {
        event.preventDefault(); // Prevents the form from submitting normally

        // Get the current step element
        const currentStepElement = document.querySelector('.mj-form-submission__step.show');
        const currentStepNumber = parseInt(currentStepElement.getAttribute('data-step'));
        const nextStepNumber = currentStepNumber + 1;

        // Get form action
        const formAction = $(this).attr('action');

        // Gather form data
        // var formData = $(this).serializeArray();

        var formData = $(this).serialize();
        var formType = $(this).find('input[name="user_role"]').val();

        var userType = $(this).find('input[name="user_type"]').val();

        formData += '&action=' + formAction;

        // Send form data via AJAX
        $.ajax({
            type: 'POST',
            url: missjones_data.ajax_url,
            data: formData,
            dataType: 'json',
            beforeSend: function () {
                // Show loading spinner before the AJAX request
            },
            success: function (response) {
                if (response.status === 'success') {
                    //alert(response.message);
                    showNotification(response.message, 'info');

                    window.location.href = response.return_url;
                    //handleStepNavigation(nextStepNumber);
                } else {
                    //alert(response.message);
                    showNotification(response.message, 'error');
                    // Handle the case where submission fails, maybe show an error message
                    // You might want to add an error message display logic here
                }
            },
            error: function (error) {
                console.error('AJAX Error:', error);
            }
        });
    }

    // Bind form submission event
    $('#signup-partnership').on('submit', handleFormSubmission);
    $('#signup-membership').on('submit', handleMemberSubmission);
});

function handleStepNavigation(stepNumber) {
    const currentStepElement = document.querySelector('.mj-form-submission__step.show');

    if (currentStepElement) {
        currentStepElement.classList.remove('show');
    }

    const nextStepElement = document.querySelector(`.mj-form-submission__step.step-${stepNumber}`);

    if (nextStepElement) {
        nextStepElement.classList.add('show');
    } else {
        return; // Exit if nextStepElement doesn't exist
    }

    const hasBtnsContainer = parseInt(nextStepElement.getAttribute('data-btns-wrapper'));
    const hasBackBtn = parseInt(nextStepElement.getAttribute('data-prev'));
    const hasNextBtn = parseInt(nextStepElement.getAttribute('data-next'));
    const hasDataSubmit = parseInt(nextStepElement.getAttribute('data-submit'));
    // const hasPaymentBtn = parseInt(nextStepElement.getAttribute('data-payment'));

    const btnsContainer = document.querySelector('.mj-form__progress');
    const backBtn = document.querySelector('.mj-form__submission-btn-prev');
    const nextBtn = document.querySelector('.mj-form__submission-btn-next');
    const signupBtn = document.querySelector('.mj-form__submission-btn');
    // const paymentBtn = document.querySelector('.mj-form__payment-btn');

    if (btnsContainer) {
        btnsContainer.style.display = hasBtnsContainer ? "flex" : "none";
    }

    if (backBtn) {
        backBtn.style.display = hasBackBtn ? "flex" : "none";
    }

    if (nextBtn) {
        nextBtn.style.display = hasNextBtn ? "flex" : "none";
    }

    if (signupBtn) {
        signupBtn.style.display = hasDataSubmit ? "flex" : "none";
    }

    if (nextBtn && !hasDataSubmit) {
        nextBtn.style.display = "flex";
    }

    // if (paymentBtn) {
    //     paymentBtn.style.display = hasPaymentBtn ? "flex" : "none";
    // }
}

// Function to parse query parameters from URL
function getMembershipQueryParams() {
    const queryParams = new URLSearchParams(window.location.search);
    const role = queryParams.get('role');
    const pricingMethod = queryParams.get('type');
    const interval = queryParams.get('interval');


    // Check if role is valid, otherwise assign default value
    const validRoles = ['venue', 'supplier', 'client'];
    const defaultRole = 'venue';
    const roleOrDefault = validRoles.includes(role) ? role : defaultRole;

    // Check if role is valid, otherwise assign default value
    const validIntervals = ['monthly', 'yearly'];
    const defaultInterval = 'monthly';
    const intervalOrDefault = validIntervals.includes(interval) ? interval : defaultInterval;

    // Check if pricing method is valid, otherwise assign default value
    const validPricingMethods = ['free', 'premium', 'premium-plus'];
    const defaultPricingMethod = 'free';
    const pricingMethodOrDefault = validPricingMethods.includes(pricingMethod) ? pricingMethod : defaultPricingMethod;

    return {
        role: roleOrDefault,
        pricingMethod: pricingMethodOrDefault,
        interval: intervalOrDefault
    };
}

jQuery(document).ready(function ($) {
    $(document).on('click', '.request-upgrade', function (e) {
        e.preventDefault();

        var btn = $(this);

        var type = btn.attr('data-type');

        var formData = {
            action: 'request_partner_upgrade', // AJAX action hook
            type: type
        };

        // Send form data via AJAX
        $.ajax({
            type: 'POST',
            url: missjones_data.ajax_url,
            data: formData,
            dataType: 'json',
            beforeSend: function () {
                // Show loading spinner before the AJAX request
                btn.text('Requesting...');
            },
            success: function (response) {
                btn.text('Request Sent');

                if (response.success === true) {
                    //alert(response.message);
                    showNotification(response.data, 'info');

                } else {
                    //alert(response.message);
                    showNotification(response.data, 'error');
                    // Handle the case where submission fails, maybe show an error message
                    // You might want to add an error message display logic here
                }
            },
            error: function (error) {
                btn.textContent = 'Upgrade Now';
                console.error('AJAX Error:', error);
            }
        });
    });
});
